import styled from '@emotion/styled/macro';
import { AppTopNavLogo, BaseButton, forPhoneOnly, Variables } from '@enter/core';

export {
    AppTopNav as MainNav,
    AppTopNavDesktopItem as DesktopItem,
    AppTopNavIcon as StyledIcon,
    AppTopNavLogo as Logo,
    AppTopNavLogoSection as LogoSection,
    AppTopNavMobileItem as MobileItem,
    AppTopNavSearchBarWrapper as SearchBarWrapper,
    AppTopNavSidebarToggle as CollapseButton,
    AppTopNavSpacer as Spacer,
} from '@enter/core';

export const LogoSpacer = styled.span`
    display: inline-flex;
    width: 80px;
`;

export const SidebarPanel = styled.div<{ light: boolean }>`
    min-width: ${Variables.sidebarSize};
    background: ${Variables.Colors.b300};
    display: flex;
    align-items: center;
    height: 100%;
    transition: all 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    border-right: solid 1px ${Variables.Colors.nx8};

    ${({ light }) =>
        light
            ? `
            background: ${Variables.Colors.ghostWhite};

            ${AppTopNavLogo} {
                background-color: none;
            }
    `
            : undefined}
`;

export const MenuButton = styled(BaseButton)`
    display: none;
    display: inline-flex;
    margin: 12px 24px;
    padding: 0 8px;
    min-width: unset;
    cursor: pointer;
    z-index: 100;
    fill: ${Variables.Colors.ghostWhite};

    ${forPhoneOnly(`
        margin: 12px;
    `)};
`;
